// extracted by mini-css-extract-plugin
export var activeFilterButton = "_kg-c";
export var backButton = "_kg-4";
export var backIcon = "_kg-5";
export var chevronShortcut = "_kg-6";
export var container = "_kg-1";
export var editor = "_kg-8";
export var editorWrapper = "_kg-7";
export var prefix = "_kg-2";
export var searchIcon = "_kg-3";
export var suffix = "_kg-9";
export var suffixContent = "_kg-a";
export var suffixText = "_kg-b";
export var wrapper = "_kg-0";